import { queryExecutionRuns } from '@/features/executionRuns/data/executionRuns';
import { queryUploads, queryResultsFiles } from '@/features/uploads/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { ExecutionRunDto, UploadDto, QueryResult, ResultsFileDto } from '@flowqa/shared';

export const fetchUploadsGrid = async (
  organisationId: string | null | undefined,
  input: GridQueryInput,
): Promise<QueryResult<UploadDto>> =>
  await queryUploads({ ...input, summaryMode: 'summary' }, organisationId ?? undefined);

export const fetchResultsFilesGrid = async (
  organisationId: string | null | undefined,
  input: GridQueryInput,
): Promise<QueryResult<ResultsFileDto>> =>
  await queryResultsFiles(
    {
      ...input,
      includeSummary: true,
      includeSummaryDetails: true,
      include: { project: false, createdBy: true, createdByEmail: true },
    },
    organisationId ?? undefined,
  );

export const fetchExecutionRunsGrid = async (
  organisationId: string | null | undefined,
  input: GridQueryInput,
): Promise<QueryResult<ExecutionRunDto>> =>
  await queryExecutionRuns(
    { ...input, includeSummary: true, includeSummaryDetails: false },
    organisationId ?? undefined,
  );
